/**
 * Product Viewed Badge Component
 * Handles tooltip toggle functionality for the product viewed badge
 */

class ProductViewedBadge {
  constructor(element) {
    this.element = element;
    this.infoButton = element.querySelector('.product-viewed-badge__info');
    this.tooltip = element.querySelector('.product-viewed-badge__tooltip');
    this.isActive = false;
    this.boundClickOutside = this.handleClickOutside.bind(this);
    this.boundEscapeKey = this.handleEscapeKey.bind(this);
    
    this.init();
  }

  init() {
    if (!this.infoButton || !this.tooltip) {
      console.warn('ProductViewedBadge: Missing required elements');
      return;
    }

    // Toggle tooltip on info button click
    this.infoButton.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.toggle();
    });

    // Prevent tooltip clicks from closing it
    this.tooltip.addEventListener('click', (e) => {
      e.stopPropagation();
    });
  }

  handleClickOutside(e) {
    if (this.isActive && !this.element.contains(e.target)) {
      this.close();
    }
  }

  handleEscapeKey(e) {
    if (e.key === 'Escape' && this.isActive) {
      this.close();
    }
  }

  toggle() {
    if (this.isActive) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.element.classList.add('is-active');
    this.isActive = true;
    this.infoButton.setAttribute('aria-expanded', 'true');
    
    // Add listeners when opening
    setTimeout(() => {
      document.addEventListener('click', this.boundClickOutside);
      document.addEventListener('keydown', this.boundEscapeKey);
    }, 0);
  }

  close() {
    this.element.classList.remove('is-active');
    this.isActive = false;
    this.infoButton.setAttribute('aria-expanded', 'false');
    
    // Remove listeners when closing
    document.removeEventListener('click', this.boundClickOutside);
    document.removeEventListener('keydown', this.boundEscapeKey);
  }
}

// Initialize function
function initProductViewedBadges() {
  const badges = document.querySelectorAll('.product-viewed-badge');
  console.log('Initializing Product Viewed Badges:', badges.length);
  badges.forEach(badge => {
    // Check if already initialized
    if (!badge.dataset.initialized) {
      new ProductViewedBadge(badge);
      badge.dataset.initialized = 'true';
    }
  });
}

// Initialize on DOMContentLoaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductViewedBadges);
} else {
  // DOM already loaded
  initProductViewedBadges();
}

// Re-initialize when Shopify section editor updates the page
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', initProductViewedBadges);
  document.addEventListener('shopify:section:reorder', initProductViewedBadges);
}

